import { render } from "./EditCompanyView.vue?vue&type=template&id=552b0b14&scoped=true"
import script from "./EditCompanyView.vue?vue&type=script&lang=js"
export * from "./EditCompanyView.vue?vue&type=script&lang=js"

import "./EditCompanyView.vue?vue&type=style&index=0&id=552b0b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552b0b14"]])

export default __exports__